import * as React from 'react';

import BaseOrgLocationListLayout from './BaseOrgLocationListLayout';

export default function (params) {
  return BaseOrgLocationListLayout();
};
